export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CLEAR_MESSAGES = "CLEAR_MESSAGES"
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

/** 
 * Clear all "global" error messages
*/
export const clearErrors = () => {
    return {
        type: CLEAR_ERRORS
    };
};

export const clearMessages = () => {
    return {
        type: CLEAR_MESSAGES
    };
};

export const clearMessage = (msgId) => {
    return {
        type: CLEAR_MESSAGE,
        id: msgId
    };
};



// WEBPACK FOOTER //
// ./src/actions/messages.js